var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "mb-0", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticStyle: { "background-color": "#ffe1ce" } },
            [
              _c("v-col", [
                _c("h1", { staticClass: "text-center main-title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-container", [
        _vm.description
          ? _c("div", {
              staticClass: "text-center main-description",
              domProps: { innerHTML: _vm._s(_vm.description) }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }